import { Injectable } from '@angular/core';

interface CompanyColors {
  background: string;
  background_secondary: string;
  primary: string;
  primary_text: string;
  secondary: string;
  secondary_text: string;
}

@Injectable({
  providedIn: 'root',
})
export class CompanyColorsService {
  setCompanyColors(colors: CompanyColors): void {
    document.documentElement.style.setProperty('--bwh-background-c', colors.background);
    document.documentElement.style.setProperty('--bwh-background-secondary-c', colors.background_secondary);
    document.documentElement.style.setProperty('--bwh-primary-c', colors.primary);
    document.documentElement.style.setProperty('--bwh-primary-text-c', colors.primary_text);
    document.documentElement.style.setProperty('--bwh-secondary-c', colors.secondary);
    document.documentElement.style.setProperty('--bwh-secondary-text-c', colors.secondary_text);
  }
}
